/**
 * ADA remediation patch — cart drawer status announcements (Ford demand letter, item #3)
 *
 * The cart drawer is rendered by a third-party app (Upcart) whose markup is not
 * part of this theme's own templates, so it can't be fixed at the source. This
 * script watches for the two dynamic elements identified during the technical
 * review — the "Cart — N Items" heading and the per-line quantity field — and
 * wires them up with the missing aria-live announcements so screen reader users
 * are told when the cart contents change, not just when they navigate back to
 * re-read them.
 *
 * Idempotent: marks each element with a data attribute once patched so repeated
 * observer callbacks don't double-wrap anything.
 */
(function () {
  var CART_COUNT_RE = /^cart\s*[—-]\s*\d+\s*items?$/i;

  function patchCartCountHeading(el) {
    if (el.dataset.adaLivePatched) return;
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.setAttribute('aria-atomic', 'true');
    el.dataset.adaLivePatched = 'true';
  }

  function patchQuantityField(input) {
    var container = input.closest('div') || input.parentElement;
    if (!container || container.dataset.adaLivePatched) return;
    container.setAttribute('aria-live', 'polite');
    container.setAttribute('aria-atomic', 'true');
    container.dataset.adaLivePatched = 'true';
  }

  function scan(root) {
    if (!(root instanceof Element) && !(root instanceof Document)) return;

    // Cart item-count heading, e.g. "Cart — 2 Items"
    var headingCandidates = root.querySelectorAll
      ? root.querySelectorAll('h1, h2, h3, h4, [role="heading"]')
      : [];
    headingCandidates.forEach(function (el) {
      var text = (el.textContent || '').trim();
      if (CART_COUNT_RE.test(text)) patchCartCountHeading(el);
    });
    if (root.nodeType === 1 && CART_COUNT_RE.test((root.textContent || '').trim())) {
      patchCartCountHeading(root);
    }

    // Per-line quantity field
    var qtyCandidates = root.querySelectorAll
      ? root.querySelectorAll('input[aria-label="Product quantity"]')
      : [];
    qtyCandidates.forEach(patchQuantityField);
  }

  // Initial pass in case the drawer is already in the DOM (e.g. pre-rendered)
  scan(document);

  // Watch for the drawer being opened/rendered/updated dynamically
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) scan(node);
      });
      if (mutation.type === 'characterData' && mutation.target.parentElement) {
        scan(mutation.target.parentElement);
      }
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
  });
})();
